import type { ReactNode } from "react";
import { Monitor, Smartphone, Tablet } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { msg } from "@lingui/core/macro";
import type { I18n } from "@lingui/core";
import type { ActiveSession } from "@/lib/auth";

/** Pick an icon for a session from its parsed device string. */
export function sessionIcon(device: string): ReactNode {
  const d = device.toLowerCase();
  if (d.includes("ipad") || d.includes("tablet")) {
    return <Tablet className="size-5" />;
  }
  if (
    d.includes("iphone") ||
    d.includes("ios") ||
    d.includes("android") ||
    d.includes("mobile")
  ) {
    return <Smartphone className="size-5" />;
  }
  return <Monitor className="size-5" />;
}

/** "Location • IP • Last seen 2 hours ago" — omits the parts we don't have. */
export function sessionSubtitle(session: ActiveSession, i18n: I18n): string {
  const date = new Date(session.lastSeenAt);
  const lastSeenAgo = Number.isNaN(date.getTime())
    ? null
    : formatDistanceToNow(date, { addSuffix: true });
  const lastSeen = lastSeenAgo ? i18n._(msg`Last seen ${lastSeenAgo}`) : null;
  return [session.location, session.ipAddress, lastSeen]
    .filter(Boolean)
    .join(" • ");
}
